import { RootState } from '../../../reducers'
import { currentBotMetadataSelector } from './currentBotMetadataSelector'

export function currentBotEnvironmentTypeSelector(state: RootState) {
  return currentBotMetadataSelector(state)?.environmentType
}
